<template>
  <article class="information_page bus_list_wrap home">

    <header class="pages_title">
      <div class="myHeader flexContainer">
        <div class="myHeaderL" @click="$router.go(-1);">
          <i class="iconfont_new icon-Left"></i>
        </div>
        <div class="myHeader textalignM">乘客资料</div>
        <div class="myHeaderR textalignR"></div>
      </div>
    </header>

    <section class="add_information_wrap pages_content">
      <div class="separation_title"><span>乘客资料</span>
      <span class="colorprimary" style="float: right;margin-right: 0.4rem;" @click="addNewContact">
         <i class="iconfont_new icon-add1"></i>添加乘车人
      </span>
      </div>

      <!-- <div class="add_information">
        <button class="little_btn add_btn" @click="addNewContact">
          <i class="iconfont icon-gengduo1"></i>
          <span>添加乘车人信息</span>
        </button>
      </div> -->

      <ul class="passenger_list_wrap">
        <template v-for="(contact, key, index) in contactList">
          <li :key="key" class="passenger_list children">
            <div class="icon_select" v-if="mode == 'choose'" @click.stop="chooseContact(contact, index)">
              <i :class="contact.IsSelected ? 'iconfont icon-xuanze primaryColor-text' : 'iconfont icon-xuanze1 primaryColor-text'"></i>
            </div>
            <div class="information_name flex_wrap column a_i_end">
              <span>姓名 :</span>
              <span>手机号 :</span>
              <span>证件类型 :</span>
              <span>证件号 :</span>
            </div>
            <div class="information_content flex_wrap column a_i_start">
              <span>{{ contact.RealName }}</span>
              <span>{{ contact.Mobile }}</span>
              <span>{{ contact.PapersType }}</span>
              <span>{{ contact.CardNO }}</span>
            </div>
            <div class="information_operation flex_wrap column j_c_around">
              <button class="little_btn redact_btn" @click="editContact(contact)">编辑</button>
              <button class="little_btn cancel_btn" @click="deleteContact(contact)">删除</button>
            </div>
          </li>
        </template>
      </ul>

      <div class="btn_wrap big-btn" v-if="mode == 'choose'"><button class="btn confirm_btn" @click="chooseComplete">选好了</button></div>
    </section>
  </article>
</template>

<script>
import contactApi from '../request/contactApi';
export default {
  name: 'MyContactManager',
  data() {
    return {
      contactList: [],
      mode: '',
    };
  },
  activated() {
    let that = this;
    this.$nextTick(function() {
      that.mode = that.$route.params.mode;
      that.getUserContact();
    });
  },
  methods: {
    getUserContact() {
      this.contactList = [];
      this.$store.commit('ticket/setBaseTicketCondition', { ContactList: this.contactList });
      this.$store.commit('boat/setBaseBoatCondition', { ContactList: this.contactList });
      let that = this;
      this.$Spin.show();
      contactApi.getContactList(this.$store.state.user.OpenId, '').then(sucRes => {
        if (sucRes.success && sucRes.data.length > 0) {
          sucRes.data.forEach(obj => {
            obj.IsSelected = false;
          });
          that.contactList = sucRes.data;
        }
        that.$Spin.hide();
      });
    },
    addNewContact() {
      this.$router.push({
        name: 'EditContact',
        params: {
          mode: 'add',
          id: 0
        }
      });
    },
    editContact(contact) {
      if (contact != undefined) {
        this.$router.push({
          name: 'EditContact',
          params: {
            mode: 'edit',
            id: contact.ID
          }
        });
      }
    },
    deleteContact(contact) {
      let that = this;
      if (contact != undefined) {
        contact.Status = false;
        contactApi.updateContact(this.$store.state.user.OpenId, contact).then(sucRes => {
          if (sucRes.success) {
            this.$Message.success(sucRes.message);
            that.getUserContact();
          }
        });
      }
    },
    chooseContact(contact, index) {
      contact.IsSelected = !contact.IsSelected;
    },
    chooseComplete() {
      let tmpArr = [];
      this.contactList.forEach(val => {
        if (val.IsSelected) {
          tmpArr.push(val);
        }
      });
      if (tmpArr.length > 0) {
        this.$store.commit('ticket/setBaseTicketCondition',{ContactList:tmpArr});
        this.$store.commit('boat/setBaseBoatCondition',{ContactList:tmpArr});
        this.$router.go(-1);
      } else {
        alert('请至少选择一位乘客！');
      }
    }
  }
};
</script>

<style lang="less" scoped>
  @import '../style/public';
  @import "../style/home.less";
.pages_title {
  background-color: transparent;
  padding: 0;
  color: #fff;
  border-bottom: none;
}

  @primary-color: #006535;
  @green:#00b780;
  @red:#ed4014;


  .add_information_wrap{
    flex: 1;
    .flex_wrap(initial,initial,initial,column);
  }
  .passenger_list_wrap{
  	flex: 1;
  	overflow-y: auto;
  	z-index: 0;
  }
  .information_page .btn_wrap{
  	padding: 1em 0;
  	border-top: 2px solid #ddd;
  }
  .information_page .separation_title{
  	border: solid #ddd;
  	border-width: 1px 0;

  }
  .add_information{
  	width: 100%;
  	height: 8vh;
  	background-color: #f8f8f8;
  	z-index: 1;
    .flex_wrap(center,center);
  	/*box-shadow: 0 0 5px rgba(0, 0, 0, .5);*/
  	/* border-bottom: 1rpx solid #888 */
  }
  .information_page .add_btn{
  	background-color: @primary-color;
  	color: #fff;
  	line-height: 4vh;
  	letter-spacing: 2px;
    text-indent: 2px;
    outline: none;
    border: none;
  }
  .information_page .add_btn:active{
  	background-color: @primary-color;
  	color: #fff
  }
  .information_page .add_btn>.iconfont {
  	margin: 0;
  	font-size: .4rem;
  }
  .passenger_list{
  	width: 95%;
  	margin: 1em auto 0;
  	background-color: #FFFFFF;
  	box-shadow: 0 0 2px rgba(0, 0, 0, .5);
  	margin-bottom: .4rem;
  	height: 15vh;
  	border-radius: 5px;
    .flex_wrap(space-between,center);
  }
  .information_name{
  	flex: 0 0 20%;
  	color: #000;
  	margin-left: .2rem;
    .flex_wrap(initial,flex-end,initial,column);
  }
  .icon_select{
  	height: 100%;
  	border-right: 1px dashed #888;
    .flex_wrap(center,center);
  }
  .icon_select>.iconfont{
  	/*margin: 0 5px 0 10px;*/
  	font-size: .7rem;
  	margin: 0 5px;
  }
  .information_content{
  	flex: 1;
  	padding-left: .1rem;
    .flex_wrap(initial,flex-start,initial,column);
  }
  .information_operation{
  	flex: 0 0 22%;
    .flex_wrap(initial,initial,initial,column);
  }
  .information_operation>.cancel_btn{
  	margin-top: .5em;
  }

  .information_name>span,.information_content>span{
  	height: 3.4vh;
  	line-height: 3.4vh;
  }

  .little_btn{
    margin: 0 10px;
    padding: 5px;
    letter-spacing: 5px;
    text-indent: 5px;
    border-radius: 5px;
    font-size: .35rem;
  }
  .sitelist_function_btn_wrap .little_btn,.information_operation .little_btn{
  	margin: .5em;
  	padding: 2px 4px;
  }
  .redact_btn,.add_site_btn{
  	background-color: @primary-color;
  	color: #fff;
  	border: 1px solid @primary-color;
  }
  .redact_btn:active,.add_site_btn:active{
  	background-color: @primary-color;
  	color: #eee;
  }
  .cancel_btn{
  	background-color: @red;
  	color: #fff;
  	border: 1px solid @red;
  }
  .cancel_btn:active{
  	color: rgb(228, 228, 228);
    	background-color: @red;
  }

  .add_site_btn{
  	width: 100%;
  	line-height: 7vh;
  	font-size: .5rem;
  	padding: 0 3%;
  }
  .big-btn{
    margin-top:0!important;
    border-top:none!important;
  }
  .big-btn button{
    background-color: @primary-color;
    color: #fff;
    -webkit-box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  }
  .primaryColor-text{
    color:  @green;
  }

</style>



// WEBPACK FOOTER //
// src/components/MyContactManager.vue